module.exports = __webpack_public_path__ + "img/honda03.f38a8b4e.png";